(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["msg-brand-usp"] && !Shopify.designMode) return;
  try {
    
  /* Scoped section JS, bundled by Shopify — no raw script node for theme-check to
     parse. Contains NO Liquid; it finds its own section root from the DOM. */
  (function () {
    function init(root) {
      if (root.dataset.msgbuReady === '1') return;
      var vid = root.querySelector('.msgbu__bg video');
      var btn = root.querySelector('[data-msgbu-toggle]');
      if (!vid || !btn) return;          // image background — nothing to control
      root.dataset.msgbuReady = '1';

      function render(isPaused) {
        btn.classList.toggle('is-paused', isPaused);
        btn.setAttribute('aria-label', isPaused ? 'Play background video' : 'Pause background video');
      }

      /* Honour reduced-motion: stop autoplay and show the play affordance instead. */
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce.matches) { vid.removeAttribute('autoplay'); vid.pause(); render(true); }

      btn.addEventListener('click', function () {
        if (vid.paused) { vid.play(); render(false); } else { vid.pause(); render(true); }
      });

      /* don't decode video frames for a tab nobody is looking at */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { vid.pause(); }
        else if (!reduce.matches && !btn.classList.contains('is-paused')) { vid.play(); }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-msgbu-root]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msg-category-carousel"] && !Shopify.designMode) return;
  try {
    
/* MSG Category Carousel — arrows + optional auto-slide.
   Runs once per page for this section type and walks every instance.
   No Liquid inside — settings arrive on data-* attributes. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root){
    if(root.dataset.msgccReady) return;
    root.dataset.msgccReady = '1';

    var track = root.querySelector('[data-msgcc-track]');
    var nav = root.querySelector('[data-msgcc-nav]');
    var prev = root.querySelector('[data-msgcc-prev]');
    var next = root.querySelector('[data-msgcc-next]');
    var pauseBtn = root.querySelector('[data-msgcc-pause]');
    if(!track || !nav) return;

    function step(){
      var card = track.querySelector('.msgcc__item');
      if(!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function overflows(){ return track.scrollWidth - track.clientWidth > 4; }
    function atStart(){ return track.scrollLeft <= 4; }
    function atEnd(){ return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }

    function sync(){
      var o = overflows();
      nav.hidden = !o;
      if(o){ prev.disabled = atStart(); next.disabled = atEnd(); }
    }

    function go(dir){
      track.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function(){ stopForGood(); go(-1); });
    next.addEventListener('click', function(){ stopForGood(); go(1); });

    var raf;
    track.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive:true });
    if('ResizeObserver' in window){ new ResizeObserver(sync).observe(track); }
    else { window.addEventListener('resize', sync); }
    sync();

    /* ---------- auto-slide ---------- */
    var enabled = root.dataset.autoplay === 'true' && !reduce.matches;
    var ms = Math.max(2, parseInt(root.dataset.speed, 10) || 5) * 1000;
    var timer = null, hovering = false, focused = false, visible = true, userPaused = false, stopped = false;

    if(pauseBtn && !enabled){ pauseBtn.hidden = true; }
    if(!enabled) return;

    function running(){ return !stopped && !userPaused && !hovering && !focused && visible && !document.hidden && overflows(); }
    function tick(){
      if(!running()) return;
      if(atEnd()){ track.scrollTo({ left:0, behavior:'smooth' }); }
      else { go(1); }
    }
    function start(){ if(!timer) timer = setInterval(tick, ms); }
    function stop(){ clearInterval(timer); timer = null; }
    function stopForGood(){
      if(!enabled) return;
      stopped = true; stop();
      if(pauseBtn) pauseBtn.hidden = true;
    }

    root.addEventListener('mouseenter', function(){ hovering = true; });
    root.addEventListener('mouseleave', function(){ hovering = false; });
    root.addEventListener('focusin', function(){ focused = true; });
    root.addEventListener('focusout', function(e){ if(!root.contains(e.relatedTarget)) focused = false; });
    /* a swipe is a deliberate choice — hand control to the visitor */
    track.addEventListener('touchstart', stopForGood, { passive:true });
    track.addEventListener('wheel', function(e){ if(Math.abs(e.deltaX) > Math.abs(e.deltaY)) stopForGood(); }, { passive:true });

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible = en[0].isIntersecting; }, { threshold:0.25 }).observe(root);
    }

    if(pauseBtn){
      var iPause = pauseBtn.querySelector('[data-icon="pause"]'), iPlay = pauseBtn.querySelector('[data-icon="play"]');
      pauseBtn.addEventListener('click', function(){
        userPaused = !userPaused;
        iPause.hidden = userPaused; iPlay.hidden = !userPaused;
        pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
      });
    }
    start();
  }

  function boot(){ document.querySelectorAll('.msgcc').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  /* Theme editor: re-bind when the merchant re-renders the section. */
  document.addEventListener('shopify:section:load', function(e){ e.target.querySelectorAll('.msgcc').forEach(init); });
  /* Theme editor: scroll a selected block into view. */
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target; if(el && el.classList && el.classList.contains('msgcc__item')){ el.scrollIntoView({ block:'nearest', inline:'start' }); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msg-featured-products"] && !Shopify.designMode) return;
  try {
    
/* Wishlist heart. It does two things, so any wishlist app can take over:
   1. dispatches "msg:wishlist:toggle" on document with { productId, handle, saved }
      — wire your wishlist app to that event (or replace the button with the app's own);
   2. remembers the saved state in this browser so the heart stays filled on reload.
   No Liquid inside — everything arrives on data-* attributes. */
(function(){
  var KEY = 'msg-wishlist';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
  function write(list){ try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){} }

  function init(root){
    root.querySelectorAll('[data-msgfp-wish]').forEach(function(btn){
      if(btn.dataset.msgfpReady) return;
      btn.dataset.msgfpReady = '1';
      var id = btn.dataset.productId;
      if(read().indexOf(id) > -1) btn.setAttribute('aria-pressed','true');
      btn.addEventListener('click', function(){
        var list = read(), i = list.indexOf(id), saved = i === -1;
        if(saved) list.push(id); else list.splice(i,1);
        write(list);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        document.dispatchEvent(new CustomEvent('msg:wishlist:toggle', { detail:{ productId:id, handle:btn.dataset.productHandle, saved:saved } }));
      });
    });
  }
  /* Card slider (mobile): mark the card that's in view so it gets the ink border. */
  function slider(root){
    if(root.dataset.mobile !== 'slider' || root.dataset.msgfpSlider || !('IntersectionObserver' in window)) return;
    root.dataset.msgfpSlider = '1';
    var grid = root.querySelector('.msgfp__grid');
    var cells = root.querySelectorAll('.msgfp__cell');
    if(!grid || !cells.length) return;
    cells[0].classList.add('is-active');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting && en.intersectionRatio > 0.6){
          cells.forEach(function(c){ c.classList.toggle('is-active', c === en.target); });
        }
      });
    }, { root: grid, threshold: [0.6] });
    cells.forEach(function(c){ io.observe(c); });
  }
  function boot(){ document.querySelectorAll('.msgfp').forEach(function(r){ init(r); slider(r); }); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ e.target.querySelectorAll('.msgfp').forEach(function(r){ init(r); slider(r); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msg-hero"] && !Shopify.designMode) return;
  try {
    
/* Runs once per page for this section type, so it walks every MSG Hero instance.
   No Liquid inside — everything it needs arrives on data-* attributes. */
(function(){
  function init(root){
    var vid = root.querySelector('.msgh__media video');
    var btn = root.querySelector('[data-msgh-toggle]');
    if(!vid || !btn || btn.dataset.msghReady) return;
    btn.dataset.msghReady = '1';

    var PAUSE = '❙❙', PLAY = '▶';

    function render(isPaused){
      btn.innerHTML = '<span aria-hidden="true">' + (isPaused ? PLAY : PAUSE) + '</span>';
      btn.setAttribute('aria-label', isPaused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    }

    /* Honour reduced-motion: stop the autoplay and show a play affordance instead. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if(reduce.matches){ vid.removeAttribute('autoplay'); vid.pause(); render(true); }

    btn.addEventListener('click', function(){
      if(vid.paused){ vid.play(); render(false); delete btn.dataset.userPaused; }
      else { vid.pause(); render(true); btn.dataset.userPaused = '1'; }
    });

    /* Don't decode video frames for a tab nobody is looking at. */
    document.addEventListener('visibilitychange', function(){
      if(document.hidden){ vid.pause(); }
      else if(!reduce.matches && !btn.dataset.userPaused){ vid.play(); }
    });
  }

  function boot(){ document.querySelectorAll('.msgh').forEach(init); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  /* Theme editor: re-bind when the merchant re-renders the section. */
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.msgh').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msg-testimonials"] && !Shopify.designMode) return;
  try {
    
  /* Scoped section JS, bundled by Shopify — no raw script node for theme-check.
     Contains NO Liquid; every value arrives on a data attribute.

     Jobs:
       1. API MODE — fetch real Okendo reviews and render them into this section's
          own card markup. Public Storefront REST API, no token:
            api.okendo.io/v1/stores/{subscriberId}/reviews
            api.okendo.io/v1/stores/{subscriberId}/products/shopify-{id}/reviews
          The subscriber ID comes from the section setting, else from the
          <meta name="oke:subscriber_id"> tag the Okendo app embed prints.
       2. WIDGET MODE — re-initialise a pasted Okendo embed after a theme-editor render.
       3. Reveal the typed quotes if nothing usable came back.
       4. Clamp long reviews and add Read more / Read less only where it overflows.
       5. Drive the rail: arrows, dots, and optional autoplay. */
  (function () {
    var API_HOST = 'https://api.okendo.io';
    var API = API_HOST + '/v1/stores/';
    var STARS = '★★★★★';
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* --------------------------------------------------------------- okendo */
    function refreshReviewApps() {
      try {
        var api = window.okeWidgetApi;
        if (api && typeof api.initAllWidgets === 'function') { api.initAllWidgets(); }
      } catch (e) { /* app absent, or a different review app — nothing to refresh */ }
    }

    function hasRendered(el) {
      return !!el && el.querySelector('*') !== null && el.offsetHeight > 40;
    }

    /* Only http(s) or site-relative links survive — a review payload must never
       be able to hand us a javascript: URL. Absolute links to a /products/ page
       are reduced to their path so the visitor stays on this storefront's domain. */
    function safeUrl(u) {
      if (!u || typeof u !== 'string') return '';
      u = u.trim();
      if (/^\/(?!\/)/.test(u)) return u;
      if (/^\/\//.test(u)) u = 'https:' + u;
      if (!/^https?:\/\//i.test(u)) return '';
      try {
        var p = new URL(u);
        if (p.pathname.indexOf('/products/') !== -1) return p.pathname + p.search;
        return p.href;
      } catch (e) { return ''; }
    }

    /* Okendo hands back full-size product images; ask the Shopify CDN for 80px. */
    function thumbUrl(u) {
      u = safeUrl(u);
      if (!u || !/^https:\/\//i.test(u)) return '';
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u) && !/[?&]width=/.test(u)) {
        u += (u.indexOf('?') === -1 ? '?' : '&') + 'width=80';
      }
      return u;
    }

    function fmtDate(iso) {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      /* DS ReviewCard shows MM/DD/YYYY — the US storefront format */
      return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    }

    /* Review text is user-submitted. Everything goes in through textContent —
       never innerHTML — so a review cannot inject markup. */
    function buildCard(rv, verifiedLabel, prefix) {
      var fig = document.createElement('figure');
      fig.className = 'msgts__card';

      var sr = document.createElement('span');
      sr.className = 'msgts__sr';
      sr.textContent = rv.rating + ' out of 5 stars';
      fig.appendChild(sr);

      var meta = document.createElement('div');
      meta.className = 'msgts__meta';
      var stars = document.createElement('span');
      stars.className = 'msgts__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = STARS.slice(0, Math.max(1, Math.min(5, Math.round(rv.rating))));
      meta.appendChild(stars);
      var when = fmtDate(rv.dateCreated);
      if (when) {
        var date = document.createElement('span');
        date.className = 'msgts__date';
        date.textContent = when;
        meta.appendChild(date);
      }
      fig.appendChild(meta);

      /* Okendo titles are written by the reviewer, so they are worth showing —
         unless the reviewer just repeated the opening of the body. */
      var title = (rv.title || '').trim();
      var body = (rv.body || '').trim();
      if (title && body.toLowerCase().indexOf(title.toLowerCase().replace(/[.…]+$/, '')) !== 0) {
        var t = document.createElement('p');
        t.className = 'msgts__title';
        t.textContent = title;
        fig.appendChild(t);
      }

      var quote = document.createElement('blockquote');
      quote.className = 'msgts__quote';
      quote.textContent = body;
      fig.appendChild(quote);

      var by = document.createElement('figcaption');
      by.className = 'msgts__by';
      var name = document.createElement('b');
      name.textContent = (rv.reviewer && rv.reviewer.displayName) || 'Verified buyer';
      by.appendChild(name);
      if (rv.reviewer && rv.reviewer.isVerified && verifiedLabel) {
        var badge = document.createElement('span');
        badge.className = 'msgts__badge';
        badge.textContent = verifiedLabel;
        by.appendChild(badge);
      }
      fig.appendChild(by);

      /* Product row. A product named in the section's own feed wins (its title,
         link and image come from Shopify); otherwise Okendo's own product fields. */
      var prod = rv._prod || {
        url: safeUrl(rv.productUrl),
        title: rv.productName || '',
        img: thumbUrl(rv.productImageUrl)
      };
      if (prod && prod.url && prod.title) {
        var link = document.createElement('a');
        link.className = 'msgts__prod';
        link.href = prod.url;
        if (prod.img) {
          var thumb = document.createElement('img');
          thumb.src = prod.img;
          thumb.alt = '';
          thumb.loading = 'lazy';
          thumb.width = 28;
          thumb.height = 28;
          link.appendChild(thumb);
        }
        var pname = document.createElement('span');
        pname.textContent = (prefix ? prefix + ' ' : '') + prod.title;
        link.appendChild(pname);
        fig.appendChild(link);
      }

      return fig;
    }

    function pick(reviews, minScore, minLen, count) {
      var seen = {};
      return reviews
        .filter(function (rv) {
          if (!rv || (rv.reviewId && seen[rv.reviewId])) return false;
          if (rv.reviewId) seen[rv.reviewId] = 1;
          if (rv.status && rv.status !== 'approved') return false;
          if (typeof rv.rating !== 'number' || rv.rating < minScore) return false;
          /* Length is the filter that matters. Without it you get 5-star reviews
             reading "Have not received them yet", which read as filler. */
          return (rv.body || '').trim().length >= minLen;
        })
        .sort(function (a, b) { return new Date(b.dateCreated) - new Date(a.dateCreated); })
        .slice(0, count);
    }

    /* ------------------------------------------------- read more / read less */
    /* Trim the TEXT, not the box.

       Every previous attempt leaned on -webkit-line-clamp, and it is unreliable
       to measure against: scrollHeight can report the box rather than the
       content, which put a Read more on reviews that already fitted, and the
       clamp limits painted lines without capping the box, which left half a line
       showing under the ellipsis. Removing the characters that do not fit ends
       both problems — what is in the DOM is exactly what is on screen.

       Binary search over the string, ~9 reflows per card, once at init. */
    function fitQuote(quote) {
      var full = quote.dataset.fullText;
      if (full === undefined) {
        full = quote.textContent;
        quote.dataset.fullText = full;
      }

      quote.textContent = full;
      var box = quote.clientHeight;              /* the fixed N-line height */
      if (!box || quote.scrollHeight <= box) return false;   /* it all fits */

      function trimAt(n) {
        /* never cut mid-word */
        return full.slice(0, n).replace(/\s+\S*$/, '') + '…';
      }

      var lo = 0, hi = full.length, best = 0;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        quote.textContent = trimAt(mid);
        if (quote.scrollHeight <= box) { best = mid; lo = mid + 1; }
        else { hi = mid - 1; }
      }
      quote.textContent = trimAt(best);
      return true;
    }

    function expandQuote(quote) {
      if (quote.dataset.fullText !== undefined) {
        quote.textContent = quote.dataset.fullText;
      }
    }

    function enhanceClamp(rail, moreLabel, lessLabel, onToggle) {
      rail.querySelectorAll('.msgts__card').forEach(function (card) {
        if (card.dataset.clampDone === '1') return;
        card.dataset.clampDone = '1';

        var quote = card.querySelector('.msgts__quote');
        if (!quote) return;

        /* A Read more that expands nothing is worse than no button at all, so
           the button only exists when text was genuinely removed. */
        if (!fitQuote(quote)) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'msgts__more';
        btn.textContent = moreLabel;
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          if (open) { expandQuote(quote); } else { fitQuote(quote); }
          btn.textContent = open ? lessLabel : moreLabel;
          btn.setAttribute('aria-expanded', String(open));
          if (onToggle) onToggle();
        });

        var caption = card.querySelector('.msgts__by');
        if (caption) { card.insertBefore(btn, caption); } else { card.appendChild(btn); }
      });
    }

    /* ------------------------------------------------------------- carousel */
    function setupRail(root, rail, nav) {
      if (!rail || !nav) return null;

      var main = rail.closest('.msgts__main') || root.querySelector('.msgts__main');
      var dotsWrap = nav.querySelector('[data-msgts-dots]');
      var prev = nav.querySelector('[data-msgts-prev]');
      var next = nav.querySelector('[data-msgts-next]');
      var pause = nav.querySelector('[data-msgts-pause]');

      var autoplayOn = root.dataset.autoplay === 'true' && !REDUCED.matches;
      var delay = parseInt(root.dataset.autoplayMs, 10) || 5000;
      var timer = null;
      var ticking = false;
      /* Two different ideas of "stopped".
         held    — transient: pointer is over the rail, focus is inside it, or the
                   tab is hidden. Resumes on its own.
         disabled — the visitor took control (arrow, dot, read more, pause button).
                   Stays off, because fighting a reader is worse than not moving. */
      var held = false;
      var disabled = false;

      function page() { return Math.max(1, rail.clientWidth); }
      function pages() { return Math.max(1, Math.ceil(rail.scrollWidth / page())); }
      function scrollable() { return rail.scrollWidth - rail.clientWidth > 4; }

      function goTo(x) {
        rail.scrollTo({ left: x, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }

      function buildDots() {
        var n = pages();
        dotsWrap.textContent = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'msgts__dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          (function (idx) {
            d.addEventListener('click', function () { stopAuto(); goTo(idx * page()); });
          })(i);
          dotsWrap.appendChild(d);
        }
      }

      function sync() {
        var i = Math.round(rail.scrollLeft / page());
        dotsWrap.querySelectorAll('.msgts__dot').forEach(function (d, k) {
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      }

      function measure() {
        var on = scrollable();
        if (main) main.classList.toggle('is-scrollable', on);
        if (!on) { clearTimer(); dotsWrap.textContent = ''; return; }
        buildDots();
        sync();
      }

      function advance() {
        if (rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2) { goTo(0); }
        else { goTo(rail.scrollLeft + page()); }
      }

      function startAuto() {
        if (!autoplayOn || disabled || held || timer || !scrollable()) return;
        timer = setInterval(advance, delay);
        if (pause) {
          pause.classList.add('is-playing');
          pause.setAttribute('aria-label', 'Pause automatic slideshow');
        }
      }
      function clearTimer() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      /* transient — no label change, it is coming back */
      function holdAuto() { held = true; clearTimer(); }
      function releaseAuto() { held = false; startAuto(); }
      /* permanent — the visitor is driving now */
      function stopAuto() {
        disabled = true;
        clearTimer();
        if (pause) {
          pause.classList.remove('is-playing');
          pause.setAttribute('aria-label', 'Play automatic slideshow');
        }
      }

      /* rAF-throttled: scroll fires far more often than the dots need updating */
      rail.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { sync(); ticking = false; });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { stopAuto(); goTo(rail.scrollLeft - page()); });
      if (next) next.addEventListener('click', function () { stopAuto(); goTo(rail.scrollLeft + page()); });
      if (pause) pause.addEventListener('click', function () {
        if (timer) { stopAuto(); } else { disabled = false; held = false; startAuto(); }
      });

      /* Reading pauses; leaving resumes. The previous build only ever stopped,
         so a single mouse-over killed autoplay for the life of the page — which
         is why it looked like it needed the play button pressed. */
      rail.addEventListener('mouseenter', holdAuto);
      rail.addEventListener('mouseleave', releaseAuto);
      rail.addEventListener('focusin', holdAuto);
      rail.addEventListener('focusout', releaseAuto);
      rail.addEventListener('pointerdown', holdAuto);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { holdAuto(); } else { releaseAuto(); }
      });

      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(measure, 150);
      });

      return { measure: measure, start: startAuto, stop: stopAuto };
    }

    /* ------------------------------------------------------------------ api */
    function readProducts(root) {
      var cfg = root.querySelector('[data-msgts-products]');
      if (!cfg) return [];
      var seen = {};
      /* Blocks and the collection can name the same product; first wins. */
      return Array.prototype.map.call(cfg.querySelectorAll('span[data-id]'), function (el) {
        return { id: el.dataset.id, title: el.dataset.title, url: el.dataset.url, img: el.dataset.img || '' };
      }).filter(function (p) {
        if (!p.id || seen[p.id]) return false;
        seen[p.id] = 1;
        return true;
      });
    }

    /* Theme editor only. Silent fallbacks are the hardest kind of bug to report. */
    function diag(root, msg) {
      if (root.dataset.editor !== 'true') return;
      var el = root.querySelector('[data-msgts-diag]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    function subscriberId(rail) {
      var k = (rail.dataset.key || '').trim();
      if (k) return k;
      var meta = document.querySelector('meta[name="oke:subscriber_id"]');
      return meta ? (meta.getAttribute('content') || '').trim() : '';
    }

    /* Okendo paginates with a nextUrl. Accept it only if it resolves to the
       Okendo API host — a relative path is anchored there, anything else dropped. */
    function nextFrom(n) {
      if (!n || typeof n !== 'string') return '';
      if (n.indexOf('/v1/') === 0) return API_HOST + n;
      if (n.charAt(0) === '/') return API_HOST + '/v1' + n;
      try { return new URL(n).origin === API_HOST ? n : ''; } catch (e) { return ''; }
    }

    /* path is '' for the store-wide feed, or '/products/shopify-<id>'.
       Keeps paging until `enough` passes the filter or maxPages is spent. */
    function fetchReviews(key, path, maxPages, enough) {
      var url = API + encodeURIComponent(key) + path +
                '/reviews?limit=25&orderBy=' + encodeURIComponent('date desc');
      var out = [];
      function step(u, left) {
        return fetch(u)
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (j) {
            out = out.concat((j && j.reviews) || []);
            var nxt = nextFrom(j && j.nextUrl);
            if (left > 1 && nxt && (!enough || !enough(out))) return step(nxt, left - 1);
            return out;
          })
          .catch(function () { return out; });
      }
      return step(url, maxPages || 1);
    }

    function loadFromApi(rail, products, onDone, onEmpty) {
      var root = rail.closest('[data-msgts-root]');
      var key = subscriberId(rail);
      if (!key) {
        diag(root, 'No Okendo subscriber ID found. Turn on the Okendo app embed under Theme settings → App embeds ' +
                   '(it prints the ID on every page), or paste the ID into "Okendo subscriber ID". Showing typed quotes instead.');
        onEmpty();
        return;
      }

      var count = parseInt(rail.dataset.count, 10) || 6;
      var minScore = parseInt(rail.dataset.minScore, 10) || 5;
      var minLen = parseInt(rail.dataset.minLen, 10);
      if (isNaN(minLen)) minLen = 60;
      var label = rail.dataset.verifiedLabel || '';
      var prefix = rail.dataset.productPrefix || '';
      var cacheKey = 'msgts:' + key + ':' + count + ':' + minScore + ':' + minLen + ':' +
                     products.map(function (p) { return p.id; }).join(',');

      function paint(list) {
        if (!list.length) { onEmpty(); return; }
        var frag = document.createDocumentFragment();
        list.forEach(function (rv) { frag.appendChild(buildCard(rv, label, prefix)); });
        rail.textContent = '';
        rail.appendChild(frag);
        rail.removeAttribute('aria-busy');
        onDone(rail);
      }

      /* One network call per browsing session, not per page view. */
      try {
        var hit = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
        if (hit && Date.now() - hit.t < 1800000) { paint(hit.v); return; }
      } catch (e) { /* private mode, or a stale shape — just refetch */ }

      function finish(list) {
        if (list.length) {
          try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), v: list })); } catch (e) {}
        }
        paint(list);
      }

      function enoughFn(all) { return pick(all, minScore, minLen, count).length >= count; }

      /* Store-wide feed: every review already carries its product. */
      function storeReviews(why) {
        fetchReviews(key, '', 4, enoughFn).then(function (all) {
          var list = pick(all, minScore, minLen, count);
          if (!list.length) {
            diag(root, 'Okendo returned ' + all.length + ' review(s) but none passed the filters (minimum rating and ' +
                       'minimum length). Showing typed quotes instead. Try lowering "Minimum review length".');
          } else {
            diag(root, why || ('Showing ' + list.length + ' live Okendo review(s) from across the store, each linking to its product.'));
          }
          finish(list);
        });
      }

      if (!products.length) { storeReviews(); return; }

      /* Product filter: one call per chosen product, merged then re-sorted by date
         so the mix reads as a single recent stream rather than product-by-product. */
      Promise.all(products.map(function (p) {
        return fetchReviews(key, '/products/shopify-' + encodeURIComponent(p.id), 1).then(function (all) {
          return all.map(function (rv) { rv._prod = p; return rv; });
        });
      })).then(function (groups) {
        var merged = [];
        groups.forEach(function (g) { merged = merged.concat(g); });
        var list = pick(merged, minScore, minLen, count);
        /* Chosen products may simply have no eligible reviews yet — fall back to
           the store-wide feed before giving up on the whole section. */
        if (!list.length) {
          storeReviews('None of the ' + products.length + ' product(s) you named have reviews passing the filters. ' +
                       'Fell back to store-wide Okendo reviews.');
          return;
        }
        diag(root, 'Product reviews loaded from ' + products.length + ' product(s). ' +
                   list.length + ' review(s) shown, each linking to its product.');
        finish(list);
      });
    }

    /* ----------------------------------------------------------------- init */
    function init(root) {
      if (root.dataset.msgtsReady === '1') return;
      root.dataset.msgtsReady = '1';

      var nav = root.querySelector('[data-msgts-nav]');
      var fallback = root.querySelector('[data-msgts-fallback]');
      var apiRail = root.querySelector('[data-msgts-api]');
      var widget = root.querySelector('[data-msgts-embed="reviews"]');
      var moreLabel = root.dataset.moreLabel || 'Read more';
      var lessLabel = root.dataset.lessLabel || 'Read less';
      var car = null;

      /* A pasted rating badge is an Okendo embed too, and it needs the app poked
         the same way the widget does. It sits above the API branch, which returns
         early — otherwise in API mode (the default) the badge would render empty.
         Retried twice because Okendo's loader may not have arrived yet. */
      if (root.querySelector('[data-msgts-embed="badge"]')) {
        refreshReviewApps();
        setTimeout(refreshReviewApps, 1500);
        setTimeout(refreshReviewApps, 4000);
      }

      function activate(rail) {
        car = setupRail(root, rail, nav);
        /* Measure after webfonts land — clamped height is wrong against a
           fallback font, and every Read more decision depends on it. */
        function run() {
          enhanceClamp(rail, moreLabel, lessLabel, function () { if (car) { car.stop(); car.measure(); } });
          if (car) { car.measure(); car.start(); }
        }
        if (document.fonts && document.fonts.ready) { document.fonts.ready.then(run); } else { run(); }
      }

      function showFallback() {
        if (apiRail) apiRail.remove();
        if (fallback) { fallback.hidden = false; activate(fallback); }
      }

      if (apiRail) { loadFromApi(apiRail, readProducts(root), activate, showFallback); return; }

      refreshReviewApps();

      if (widget) {
        if (!fallback) return;
        function check() {
          if (hasRendered(widget)) { fallback.hidden = true; }
          else if (fallback.hidden) { fallback.hidden = false; activate(fallback); }
        }
        setTimeout(check, 3000);
        setTimeout(check, 6000);
        return;
      }

      if (fallback || root.querySelector('.msgts__rail')) {
        activate(root.querySelector('.msgts__rail'));
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-msgts-root]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
